export const toRunes = () => "/runes";
export const toRunewords = () => "/runewords";
export const toUniques = () => "/uniques";
export const toSets = () => "/sets";